import {
  Button,
  Col,
  Collapse,
  Image,
  Modal,
  Row,
  Skeleton,
  Space,
  Table,
} from 'antd';
import { Dropdown } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import CustomPagination from 'components/table/pagination';
import DashboardContext from 'Context';
import toaster from 'helper/toaster';
import InputControl from 'components/inputs/InputControl';
import InputDate from 'components/inputs/InputDate';
import InputControlAsync from 'components/inputs/InputControlAsync';
import FileUploader from 'components/fileUploader';
import Excel from 'components/table/excel';
import InputControlMulti from 'components/inputs/InputControlMulti';

export default function ExpertTicket({ id = null }) {
  const { urlHcm, authentication, handelerrors, urldashboard } =
    useContext(DashboardContext);

  // table data
  const [data, setData] = useState([]);
  const [info, setInfo] = useState({});
  const [history, setHistory] = useState([]);
  const [formData, setFormData] = useState({});
  const [filterData, setFilterData] = useState({});
  const [replyData, setReplyData] = useState({});
  const [loading, setLoading] = useState(false);
  const [historyIsLoading, setHistoryIsLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [isCleared, setIsCleared] = useState(false);
  const [closeIsLoading, setCloseIsLoading] = useState(false);
  const [workerLinkLoading, setWorkerLinkLoading] = useState(false);
  const [workerId, setWorkerId] = useState(null);
  const [expertKey, setExpertKey] = useState(null);
  const [rowId, setRowId] = useState('');
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [formModal, setFormModal] = useState(false);
  const [replyModal, setReplyModal] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitReplyLoading, setSubmitReplyLoading] = useState(false);

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const getList = async ({ page, pageSize, filterData, hcmId = null }) => {
    setLoading(true);
    try {
      let url = '/expertTicketQuery/get';
      const res = await Axios.get(urlHcm + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
        params: {
          pageNumber: page,
          recordsPerPage: pageSize,
          ...filterData,
          expertId: hcmId ?? expertKey ?? filterData?.expertId,
        },
      });
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalCount);
      setPagination({
        page: data?.pageNumber,
        pageSize: data?.recordsPerPage,
        total: data?.totalCount,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getList({
      page: newPage,
      pageSize: newPageSize,
      filterData,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'عملیات',
      key: 'actions',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Dropdown>
          <Dropdown.Toggle
            style={{ backgroundColor: '#464dee', color: '#ffffff' }}
          ></Dropdown.Toggle>

          <Dropdown.Menu id={record?.id} align={'right'}>
            <Dropdown.Item
              className={'d-inline-flex'}
              onClick={() =>
                handleReply(record?.id, record?.ticketStatus === 'بسته شده')
              }
            >
              {record?.ticketStatus === 'بسته شده' ? 'نمایش جزئیات' : 'پاسخ'}
            </Dropdown.Item>
            {record?.ticketStatus !== 'بسته شده' && (
              <Dropdown.Item
                className={'d-inline-flex'}
                onClick={() => handleClose(record?.id)}
              >
                بستن
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
    {
      title: 'نام نیرو',
      dataIndex: 'expertName',
      key: 'expertName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'ثبت‌کننده',
      dataIndex: 'creatorUserName',
      key: 'creatorUserName',
      responsive: ['xl', 'lg', 'md'],
      render: (value, record) => (
        <span>
          {value
            ? record?.persianCreateOn
              ? value + ' ' + record?.persianCreateOn
              : value
            : '-'}
        </span>
      ),
    },
    {
      title: 'نوع تعهد',
      dataIndex: 'committed',
      key: 'committed',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'شماره موبایل',
      dataIndex: 'cellphone',
      key: 'cellphone',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'واحد',
      dataIndex: 'companyUnitName',
      key: 'companyUnitName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'دسته‌بندی',
      dataIndex: 'companyUnitSubgroupName',
      key: 'companyUnitSubgroupName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'عنوان',
      dataIndex: 'companyUnitSubgroupProblemTitle',
      key: 'companyUnitSubgroupProblemTitle',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'آخرین تغییر توسط',
      dataIndex: 'lastActionUserName',
      key: 'lastActionUserName',
      responsive: ['xl', 'lg', 'md'],
      render: (value, record) => (
        <span>
          {value
            ? record?.persianLastActionDate
              ? value + ' ' + record?.persianLastActionDate
              : value
            : '-'}
        </span>
      ),
    },
    {
      title: 'وضعیت',
      dataIndex: 'ticketStatus',
      key: 'ticketStatus',
      responsive: ['xl', 'lg', 'md'],
      render(value, record) {
        return {
          props: {
            style: {
              background:
                value === 'بسته شده'
                  ? 'rgba(255, 30, 0, 0.28)'
                  : value === 'در انتظار پاسخ نیرو'
                  ? 'rgba(139, 184, 255, 0.28)'
                  : '#fffdd0',
            },
          },
          children: <span>{value ?? '-'}</span>,
        };
      },
    },
  ];

  const submit = async () => {
    if (
      !expertKey &&
      (formData?.expertId === null || formData?.expertId === undefined)
    ) {
      return toaster.error('لطفا نیرو را وارد کنید.');
    }

    if (
      formData?.companyUnitSubgroupId === null ||
      formData?.companyUnitSubgroupId === undefined
    ) {
      return toaster.error('لطفا دسته‌بندی را وارد کنید.');
    }

    if (
      formData?.companyUnitSubgroupProblemId === null ||
      formData?.companyUnitSubgroupProblemId === undefined
    ) {
      return toaster.error('لطفا موضوع تیکت را وارد کنید.');
    }

    setSubmitLoading(true);

    formData.expertId = expertKey ?? formData?.expertId;

    try {
      let url = '/expertTicketCommand/create';

      function objectToFormData(obj) {
        const command = new FormData();
        Object.entries(obj).forEach(([key, value]) => {
          command.append(key, value);
        });
        command.delete('attachmentFile');
        obj.attachmentFile?.forEach((_, index) => {
          command.append('attachmentFile', obj.attachmentFile[index]);
        });
        return command;
      }

      const fdCommand = objectToFormData(formData);

      await Axios.post(urlHcm + url, fdCommand, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'multipart/form-data',
        },
      });

      toaster.success('عملیات با موفقیت انجام شد.');
      setSubmitLoading(false);
      setFormModal(false);
      setFormData({});
      getList({
        page: 1,
        pageSize: 10,
        filterData,
      });
    } catch (error) {
      handelerrors(error);
      setSubmitLoading(false);
    }
  };

  const handleClose = async (id) => {
    setCloseIsLoading(true);
    try {
      await Axios.post(
        `${urlHcm}/expertTicketCommand/close`,
        JSON.stringify({ ticketId: id }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      setCloseIsLoading(false);
      toaster?.success('عملیات با موفقیت انجام شد.');
      replyModal && setReplyModal(false);
      getList({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        filterData,
      });
    } catch (error) {
      handelerrors(error);
      setCloseIsLoading(false);
    }
  };

  const handleChangeFilter = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const search = () => {
    getList({
      page: 1,
      pageSize: 10,
      filterData,
    });
  };

  const options = [
    {
      label: 'در انتظار پاسخ کارشناس',
      value: 0,
    },
    {
      label: 'در انتظار پاسخ نیرو',
      value: 1,
    },
    {
      label: 'بسته شده',
      value: 2,
    },
  ];

  // reply

  const handleChangeReply = (name, value) => {
    setReplyData({ ...replyData, [name]: value });
  };

  const handleReply = async (id, readOnly) => {
    setRowId(id);
    setReadOnly(readOnly);
    getReplyHistory(id);
    setReplyModal(true);
  };

  const getReplyHistory = async (id) => {
    setHistoryIsLoading(true);
    try {
      let url = `/expertTicketQuery/getById/${id}`;
      const response = await Axios.get(urlHcm + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await response?.data;
      setInfo(data);
      setHistory(data?.ticketComments?.reverse());
      setHistoryIsLoading(false);
    } catch (error) {
      handelerrors(error);
      setHistoryIsLoading(false);
    }
  };

  const [type, setType] = useState(0);
  const [selectedText, setSelectedText] = useState('');
  const [selectedItemId, setSelectedItemId] = useState(null);

  const submitReply = async () => {
    if (!replyData?.message) {
      return toaster.error('لطفا پاسخ را وارد کنید.');
    }

    const fields = {
      ...replyData,
      ticketId: rowId,
    };

    if (type === 1) fields.replyId = selectedItemId;
    if (type === 2) {
      fields.commentId = selectedItemId;
      delete fields?.attachmentFile;
    }
    setIsCleared(false);
    setSubmitReplyLoading(true);

    try {
      let url =
        type === 2
          ? '/expertTicketCommand/modify'
          : '/expertTicketCommand/comment';

      function objectToFormData(obj) {
        const command = new FormData();
        Object.entries(obj).forEach(([key, value]) => {
          command.append(key, value);
        });
        command.delete('attachmentFile');
        obj.attachmentFile?.forEach((_, index) => {
          command.append('attachmentFile', obj.attachmentFile[index]);
        });
        return command;
      }

      const fdCommand = objectToFormData(fields);

      type === 2
        ? await Axios.put(urlHcm + url, fields, {
            headers: {
              Authorization: authentication,
              'Content-Type': 'application/json',
            },
          })
        : await Axios.post(urlHcm + url, fdCommand, {
            headers: {
              Authorization: authentication,
              'Content-Type': 'multipart/form-data',
            },
          });

      toaster.success('عملیات با موفقیت انجام شد.');
      setSubmitReplyLoading(false);
      handleCancelReply();
      setSelectedItemId(null);
      setSelectedText('');
      setType(0);
      getReplyHistory(rowId);

      // const messageBody = document.querySelector('.chat-box');
      // if (messageBody && shouldScroll) {
      //   messageBody.scrollTop =
      //     messageBody.scrollHeight - messageBody.clientHeight;
      // }
    } catch (error) {
      handelerrors(error);
      setSubmitReplyLoading(false);
    }
  };

  let messageBody = document.querySelector('.chat-box');
  if (messageBody)
    messageBody.scrollTop = messageBody.scrollHeight - messageBody.clientHeight;

  const handleCancelReply = () => {
    setReplyData({});
    if (!readOnly) document.getElementById('message').value = '';
    setIsCleared(true);
  };

  // hcm dropdowns

  const handleCollapse = (value) => {
    if (value?.length > 1) {
      getUnits();
    }
  };

  const [units, setUnits] = useState([]);
  const [problems, setProblems] = useState([]);
  const [categories, setCategories] = useState([]);
  const [unitsLoading, setUnitsLoading] = useState(false);
  const [problemsLoading, setProblemsLoading] = useState(false);
  const [categoriesLoading, setCategoriesLoading] = useState(false);

  const getUnits = async () => {
    setUnitsLoading(true);
    try {
      let url = `/companyUnitQuery/getDropdown`;
      const response = await Axios.get(urlHcm + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await response?.data;
      setUnits(
        data?.map((item) => {
          return {
            label: item?.value,
            value: item?.key,
          };
        })
      );
      setUnitsLoading(false);
    } catch (error) {
      handelerrors(error);
      setUnitsLoading(false);
    }
  };

  const getCategories = async (unitId) => {
    setCategoriesLoading(true);
    try {
      let url = `/companyUnitSubgroupQuery/getDropdown/${unitId}`;
      const response = await Axios.get(urlHcm + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await response?.data;
      setCategories(
        data?.map((item) => {
          return {
            label: item?.value,
            value: item?.key,
          };
        })
      );
      setCategoriesLoading(false);
    } catch (error) {
      handelerrors(error);
      setCategoriesLoading(false);
    }
  };

  useEffect(() => {
    filterData?.companyUnitId !== null &&
      filterData?.companyUnitId !== undefined &&
      getCategories(filterData?.companyUnitId);
  }, [filterData?.companyUnitId]);

  const getProblems = async (categoryId, expertId, subSystemType) => {
    setProblemsLoading(true);
    try {
      let url =
        subSystemType !== null && subSystemType !== undefined
          ? `/companyUnitSubgroupProblemQuery/getDropdownBySubSystemType/${categoryId}/${subSystemType}`
          : `/companyUnitSubgroupProblemQuery/getDropdown/${categoryId}/${
              expertKey ?? expertId
            }`;
      const response = await Axios.get(urlHcm + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await response?.data;
      setProblems(
        data?.map((item) => {
          return {
            label: item?.value,
            value: item?.key,
          };
        })
      );
      setProblemsLoading(false);
    } catch (error) {
      handelerrors(error);
      setProblemsLoading(false);
    }
  };

  useEffect(() => {
    filterData?.companyUnitSubgroupId !== null &&
      filterData?.companyUnitSubgroupId !== undefined &&
      (filterData?.expertId ||
        expertKey ||
        (filterData?.subSystemType !== null &&
          filterData?.subSystemType !== undefined)) &&
      getProblems(
        filterData?.companyUnitSubgroupId,
        filterData?.expertId,
        filterData?.subSystemType
      );
  }, [
    filterData?.companyUnitSubgroupId,
    filterData?.expertId,
    filterData?.subSystemType,
  ]);

  const handleDelete = async (messageId) => {
    setHistoryIsLoading(true);
    try {
      const res = await Axios.delete(`${urlHcm}/expertTicketCommand/delete`, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
        data: {
          commentId: messageId,
          ticketId: rowId,
        },
      });
      setHistoryIsLoading(false);
      const data = res?.data;
      toaster.success(data.message);
      getReplyHistory(rowId);
    } catch (error) {
      handelerrors(error);
      setHistoryIsLoading(false);
    }
  };

  const handleSpecificReply = (id) => {
    setSelectedItemId((prevId) => {
      if (prevId === id) {
        setType(0);
        return null;
      }
      setType(1);
      return id;
    });
  };

  const handleEdit = (id, text) => {
    setType(2);
    setSelectedItemId(id);
    setSelectedText(text || '');
  };

  const getWorkerId = async (phoneNumber) => {
    setWorkerLinkLoading(true);
    try {
      let url = `/worker/getByPhoneNumber/${phoneNumber}`;
      const res = await Axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const data = await res.data.data;
      setWorkerId(data?.userId);
      setWorkerLinkLoading(false);
    } catch (error) {
      setWorkerLinkLoading(false);
      setWorkerId(null);
    }
  };

  useEffect(() => {
    getWorkerId(info?.cellphone);
  }, [info?.cellphone]);

  useEffect(() => {
    const handlePaste = (event) => {
      const items = event.clipboardData.items;
      for (let item of items) {
        if (item.type.startsWith('image/')) {
          const file = item.getAsFile();
          setFormData((prev) => ({ ...prev, attachmentFile: file }));
        }
      }
    };

    document.addEventListener('paste', handlePaste);
    return () => document.removeEventListener('paste', handlePaste);
  }, []);

  useEffect(() => {
    if (id) {
      getExpertName(id);
    } else {
      getList({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        filterData,
      });
      setInfo({});
      setRowId({});
    }
  }, [id]);

  const getExpertName = async (id) => {
    setLoading(true);

    let command = [id];
    try {
      let url = '/worker/bulksearch';
      const res = await Axios.post(urldashboard + url, command, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      const name = res?.data?.data[0]?.label?.match(/^[^(]+/)[0].trim();
      getExpertId(name);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      return toaster.error('خطا در دریافت اطلاعات نیرو. (crm)');
    }
  };

  const getExpertId = async (name) => {
    setLoading(true);
    try {
      let url = `/expertQuery/autoCompleteDropDown/${name}`;
      const res = await Axios.get(urlHcm + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
      });
      setExpertKey(res?.data[0]?.key);
      getList({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
        filterData,
        hcmId: res?.data[0]?.key,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      return toaster.error('خطا در دریافت اطلاعات نیرو. (hcm)');
    }
  };

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <Collapse defaultActiveKey={['0']} onChange={handleCollapse}>
            <Collapse.Panel header='جستجو پیشرفته' key='1'>
              {/* */}
              <Row align={'middle'} gutter={20}>
                <Col xl={4} lg={4} md={12} sm={24} xs={24}>
                  <InputControl
                    staticData={options}
                    label='وضعیت'
                    name='ticketStatus'
                    handelValue={(_, value) =>
                      handleChangeFilter('ticketStatus', value)
                    }
                  />
                </Col>
                {!expertKey && (
                  <Col xl={5} lg={5} md={12} sm={24} xs={24}>
                    <InputControlAsync
                      fromHcm
                      url='/expertQuery/autoCompleteDropDown'
                      label={
                        <div>
                          انتخاب نیرو
                          <small>
                            {' '}
                            (برای انتخاب موضوع تیکت نیروی مورد نظر را انتخاب
                            کنید.)
                          </small>
                        </div>
                      }
                      name='expertId'
                      handelValue={(_, value) =>
                        handleChangeFilter('expertId', value)
                      }
                    />
                  </Col>
                )}
                <Col xl={5} lg={5} md={12} sm={24} xs={24}>
                  <InputDate
                    label='تاریخ ثبت از'
                    name='fromDate'
                    handelValue={(_, value) =>
                      handleChangeFilter(
                        'fromDate',
                        value ? `${value}T00:00` : null
                      )
                    }
                  />
                </Col>
                <Col xl={5} lg={5} md={12} sm={24} xs={24}>
                  <InputDate
                    label='تاریخ ثبت تا'
                    name='toDate'
                    handelValue={(_, value) =>
                      handleChangeFilter(
                        'toDate',
                        value ? `${value}T00:00` : null
                      )
                    }
                  />
                </Col>
                <Col xl={5} lg={5} md={12} sm={24} xs={24}>
                  <InputControlMulti
                    url='/hrBaseInformation/getHRUserlist'
                    label='کارشناسهای پشتیبان'
                    name='supportUserIds'
                    handelValue={(_, value) =>
                      handleChangeFilter('supportUserIds', value)
                    }
                  />
                </Col>
                <Col xl={5} lg={5} md={12} sm={24} xs={24}>
                  <InputControl
                    name='subSystemType'
                    url='/common/getSubSystemType'
                    label={
                      <div>
                        نوع زیرسیستم
                        <small>
                          {' '}
                          (برای انتخاب موضوع تیکت، زیرسیستم را انتخاب کنید.)
                        </small>
                      </div>
                    }
                    handelValue={(_, value) =>
                      handleChangeFilter('subSystemType', value)
                    }
                  />
                </Col>
                <Col xl={4} lg={4} md={12} sm={24} xs={24}>
                  <InputControlMulti
                    noNested
                    url='/roles/roleForHcmDropdown'
                    label='نقشها'
                    name='roles'
                    handelValue={(_, value) =>
                      handleChangeFilter('roles', value)
                    }
                  />
                </Col>
                <Col xl={5} lg={5} md={12} sm={24} xs={24}>
                  {unitsLoading ? (
                    <Skeleton.Input block size='large' />
                  ) : (
                    <InputControl
                      staticData={units}
                      label='واحد تیکت'
                      name='companyUnitId'
                      handelValue={(_, value) =>
                        handleChangeFilter('companyUnitId', value)
                      }
                    />
                  )}
                </Col>
                <Col xl={5} lg={5} md={12} sm={24} xs={24}>
                  {filterData?.companyUnitId !== null &&
                    filterData?.companyUnitId !== undefined && (
                      <>
                        {categoriesLoading ? (
                          <Skeleton.Input block size='large' />
                        ) : (
                          <InputControl
                            staticData={categories}
                            label='دسته‌بندی تیکت'
                            name='companyUnitSubgroupId'
                            handelValue={(_, value) =>
                              handleChangeFilter('companyUnitSubgroupId', value)
                            }
                          />
                        )}
                      </>
                    )}
                </Col>
                <Col xl={5} lg={5} md={12} sm={24} xs={24}>
                  {filterData?.companyUnitId !== null &&
                    filterData?.companyUnitId !== undefined &&
                    filterData?.companyUnitSubgroupId !== null &&
                    filterData?.companyUnitSubgroupId !== undefined &&
                    ((filterData?.expertId !== null &&
                      filterData?.expertId !== undefined) ||
                      expertKey ||
                      (filterData?.subSystemType !== null &&
                        filterData?.subSystemType !== undefined)) && (
                      <>
                        {problemsLoading ? (
                          <Skeleton.Input block size='large' />
                        ) : (
                          <InputControl
                            staticData={problems}
                            label='موضوع تیکت'
                            name='companyUnitSubgroupProblemId'
                            handelValue={(_, value) =>
                              handleChangeFilter(
                                'companyUnitSubgroupProblemId',
                                value
                              )
                            }
                          />
                        )}
                      </>
                    )}
                </Col>
              </Row>
              {/* */}
              <Row
                gutter={20}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: 20,
                }}
              >
                <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                  <Button
                    type='primary'
                    style={{ width: '100%' }}
                    loading={loading}
                    onClick={() => search()}
                  >
                    جستجو
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      </div>

      <Row
        gutter={20}
        style={{
          marginTop: 25,
        }}
      >
        <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 20 }}>
          <Space
            wrap
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Button
              block
              onClick={() => setFormModal(true)}
              style={{ height: '3rem' }}
              type='primary'
              className='btn btn-primary border border-secondary rounded-0'
            >
              ثبت تیکت
              <i className='mdi mdi-plus mr-2'></i>
            </Button>
            <Excel
              fromHcm
              methodIsGet
              server
              fileName={'تیکتها'}
              url={'/expertTicketQuery/excel'}
              props={{
                ...filterData,
                pageNumber: pagination?.page,
                recordsPerPage: pagination?.pageSize,
              }}
            />
          </Space>
        </Col>
      </Row>

      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 10 }}
        rowClassName={() => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading || closeIsLoading}
        pagination={false}
        locale={{
          emptyText: 'موردی یافت نشد',
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
        />
      )}

      {formModal && (
        <Modal
          title={'ثبت تیکت'}
          open={formModal}
          onCancel={() => {
            setFormModal(false);
            setSelectedItemId(null);
            setFormData({});
          }}
          closable={false}
          width={1000}
          footer={[
            <Button
              block
              key='submit'
              loading={submitLoading}
              onClick={() => submit()}
              className='btn btn-primary rounded-0'
            >
              ثبت
            </Button>,
          ]}
          bodyStyle={{ minHeight: 400, overflowY: 'auto' }}
        >
          <Row gutter={20}>
            {!expertKey && (
              <Col span={24}>
                <InputControlAsync
                  fromHcm
                  url='/expertQuery/autoCompleteDropDown'
                  label='انتخاب نیرو'
                  name='expertId'
                  handelValue={(_, value) => handleChange('expertId', value)}
                />
              </Col>
            )}
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              <InputControl
                fromHcm
                url='/companyUnitSubgroupQuery/getDropdown'
                label='دسته‌بندی تیکت'
                name='companyUnitSubgroupId'
                handelValue={(_, value) =>
                  handleChange('companyUnitSubgroupId', value)
                }
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12}>
              {formData?.companyUnitSubgroupId &&
                (formData?.expertId ||
                  expertKey ||
                  formData?.subSystemType) && (
                  <InputControl
                    fromHcm
                    url={
                      formData?.subSystemType !== null &&
                      formData?.subSystemType !== undefined
                        ? `/companyUnitSubgroupProblemQuery/getDropdownBySubSystemType/${formData?.companyUnitSubgroupId}/${formData?.subSystemType}`
                        : `/companyUnitSubgroupProblemQuery/getDropdown/${
                            formData?.companyUnitSubgroupId
                          }/${expertKey ?? formData?.expertId}`
                    }
                    label='موضوع تیکت'
                    name='companyUnitSubgroupProblemId'
                    handelValue={(_, value) =>
                      handleChange('companyUnitSubgroupProblemId', value)
                    }
                  />
                )}
            </Col>
            <Col span={24}>
              <div className='form-group'>
                <label htmlFor='message'>توضیحات</label>
                <textarea
                  className='form-control'
                  id='message'
                  rows='6'
                  onChange={(e) => handleChange('message', e.target.value)}
                />
              </div>
            </Col>
            <Col span={24}>
              <FileUploader
                allowMultiple
                maxFiles={1}
                label={'تصویر ضمیمه'}
                setFile={(value) => handleChange('attachmentFile', value)}
              />
            </Col>
          </Row>
        </Modal>
      )}

      {replyModal && (
        <Modal
          title={
            historyIsLoading || workerLinkLoading ? (
              <Skeleton.Input />
            ) : (
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <span>
                  تیکت {info?.companyUnitSubgroupProblemTitle} -{' '}
                  {workerId ? (
                    <a
                      href={`/Worker/${workerId}`}
                      target={'_blank'}
                      rel={'noreferrer'}
                    >
                      {info?.expertName} ({info?.cellphone})
                    </a>
                  ) : (
                    <>
                      {info?.expertName} ({info?.cellphone})
                    </>
                  )}
                </span>
                <span
                  key='back'
                  onClick={() => {
                    setReplyModal(false);
                    handleCancelReply();
                  }}
                >
                  X
                </span>
              </div>
            )
          }
          open={replyModal}
          onCancel={() => {
            setReplyModal(false);
            handleCancelReply();
            getList({
              page: pagination?.page,
              pageSize: pagination?.pageSize,
              filterData,
            });
          }}
          closable={false}
          width={700}
          footer={null}
          bodyStyle={{ minHeight: 400, overflowY: 'auto' }}
        >
          <Row>
            <Col span={24}>
              <div className='chat-box'>
                {history?.map((item, index) => (
                  <Row key={item?.createOn}>
                    <Col
                      span={24}
                      className={item?.isExpert ? 'text-left' : 'text-right'}
                    >
                      <Space direction='vertical' style={{ margin: '1rem 0' }}>
                        <small style={{ color: '#a3a3a3' }}>
                          {item?.creatorName}
                        </small>
                        <div
                          id={item?.id}
                          className={
                            item?.isExpert
                              ? selectedItemId === item?.id
                                ? 'bubble selected-bubble expert-bubble'
                                : 'bubble expert-bubble'
                              : selectedItemId === item?.id
                              ? 'bubble selected-bubble hr-bubble'
                              : 'bubble hr-bubble'
                          }
                        >
                          {!readOnly && (
                            <div className='bubble-options'>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  justifyContent: 'center',
                                  height: '100%',
                                }}
                              >
                                {/* <span
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleDelete(item?.id)}
                                >
                                  <i className='mdi mdi-close-circle'></i>
                                </span> */}
                                {!item?.isExpert && (
                                  <span
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                      handleEdit(item?.id, item?.message)
                                    }
                                  >
                                    <i className='mdi mdi-pencil'></i>
                                  </span>
                                )}
                                <span
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleSpecificReply(item?.id)}
                                >
                                  <i className='mdi mdi-reply'></i>
                                </span>
                              </div>
                            </div>
                          )}
                          {item?.replyId && (
                            <div
                              style={{
                                padding: '0.5rem',
                                background: item?.isExpert
                                  ? 'lightblue'
                                  : 'beige',
                                wordBreak: 'break-word',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '2px',
                                borderRadius: '12px',
                                cursor: 'pointer',
                              }}
                            >
                              <i className='mdi mdi-format-quote-close'></i>
                              <small
                                dangerouslySetInnerHTML={{
                                  __html: item?.replyMessage?.replace(
                                    /\n/g,
                                    '<br>'
                                  ),
                                }}
                              />
                            </div>
                          )}
                          {item?.attachmentFileUrl && (
                            <Image
                              width={100}
                              height={100}
                              src={item?.attachmentFileUrl}
                            />
                          )}
                          <span
                            style={{
                              marginTop: '.5rem',
                              wordBreak: 'break-word',
                            }}
                          >
                            {item?.message}
                          </span>
                        </div>
                        <small style={{ color: '#a3a3a3' }}>
                          {item?.persianCreateOn}
                        </small>
                      </Space>
                    </Col>
                  </Row>
                ))}
              </div>
            </Col>
          </Row>
          {!readOnly && (
            <Row gutter={10} style={{ marginTop: '1rem' }}>
              <Col span={3}>
                <Button
                  style={{ height: '7.1rem', marginTop: '1.9rem' }}
                  htmlType='button'
                  block
                  type='primary'
                  loading={submitReplyLoading}
                  onClick={submitReply}
                >
                  <i className='mdi mdi-arrow-up'></i>
                </Button>
              </Col>
              <Col span={21}>
                <div className='form-group'>
                  <label htmlFor='message'>پاسخ</label>
                  <textarea
                    disabled={historyIsLoading}
                    className='form-control'
                    id='message'
                    value={selectedText}
                    rows='6'
                    onChange={(e) => {
                      setSelectedText(e.target.value);
                      handleChangeReply('message', e.target.value);
                    }}
                  />
                </div>
              </Col>
              <Col span={24}>
                <FileUploader
                  allowMultiple
                  maxFiles={1}
                  isCleared={isCleared}
                  label={'تصویر ضمیمه'}
                  setFile={(value) =>
                    handleChangeReply('attachmentFile', value)
                  }
                />
              </Col>
              <Col span={24}>
                <Button
                  type='primary'
                  danger
                  block
                  loading={closeIsLoading}
                  onClick={() => handleClose(rowId)}
                >
                  بستن تیکت
                </Button>
              </Col>
            </Row>
          )}
        </Modal>
      )}
    </>
  );
}
